import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBaby = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-baby-icon lucide-baby",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 12h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.38 6.813A9 9 0 0 1 20.8 10.2a2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 12h.01" })
	]
});
export default SvgBaby;
